import React from "react";
import ReactDom from "react-dom";

import "./index.css";

// setup vars
import { books } from "../src/books";

function App() {
  return (
    <div>
      <BookList></BookList>
    </div>
  );
}

function BookList() {
  return (
    <section className="bookList">
      {books.map((book) => {
        return <Book book={book} key={book.title}></Book>;
      })}
    </section>
  );
}

const Book = (props) => {
  const { img, title, author } = props.book;
  return (
    <div className="book">
      <img src={img} alt="" />
      <h1 className="title">{title}</h1>
      <h2>{author}</h2>
    </div>
  );
};

ReactDom.render(<App />, document.getElementById("root"));
